// Layout of the A&M Premium Partner badge with the company logo
// (Asana 1213410886347834). Same numbers as the funnel footer in funnel-app
// (src/components/Footer/partnerBadgeLayout.js), so the preview here shows
// exactly what the funnel shows; change both together.
import badgeLight from "../../assets/partner-badge/partner-badge-light.webp";
import badgeDark from "../../assets/partner-badge/partner-badge-dark.webp";
import { PARTNER_LOGO_MODE, PARTNER_LOGO_SCALE } from "../strings";

// Badge files are 800 x 391 px. The empty panel per file in % of the badge,
// measured on the 1794 x 877 originals (the two panels differ slightly).
export const BADGE_ASPECT = 391 / 800;
const BADGES = {
  [PARTNER_LOGO_MODE.AUTO_LIGHT]: {
    src: badgeLight,
    area: { left: 39.13, top: 42.42, width: 55.24, height: 34.32 }
  },
  [PARTNER_LOGO_MODE.AUTO_DARK]: {
    src: badgeDark,
    area: { left: 40.47, top: 42.08, width: 54.85, height: 33.41 }
  }
};
// Gap between logo and panel edge, a share of the panel height on all sides
const PADDING_SHARE = 0.12;

const round = (value) => Math.round(value * 100) / 100;

export const getPartnerLogoMode = (mode) =>
  BADGES[mode] ? mode : PARTNER_LOGO_MODE.MANUAL;

// 50-100; missing or not a number = 100, out of range = nearest limit
export const getPartnerLogoScale = (value) => {
  const scale = Number(value);
  if (value === null || value === "" || !Number.isFinite(scale)) {
    return PARTNER_LOGO_SCALE.MAX;
  }
  return Math.min(
    PARTNER_LOGO_SCALE.MAX,
    Math.max(PARTNER_LOGO_SCALE.MIN, Math.round(scale))
  );
};

// Logo box in % of the badge: the panel minus the gap, scaled around its centre
export const getLogoBox = (area, scale) => {
  const padTop = area.height * PADDING_SHARE;
  const padLeft = padTop * BADGE_ASPECT; // same pixels, in % of the width
  const width = ((area.width - 2 * padLeft) * scale) / 100;
  const height = ((area.height - 2 * padTop) * scale) / 100;
  return {
    left: round(area.left + (area.width - width) / 2),
    top: round(area.top + (area.height - height) / 2),
    width: round(width),
    height: round(height)
  };
};

/**
 * Badge for a mode and size, or null for MANUAL (uploaded image).
 *
 * @param {string} mode - design.partnerLogoMode
 * @param {number|string} scale - design.partnerLogoScale
 * @returns {{src: string, logoBox: Object}|null}
 */
export const getPartnerBadge = (mode, scale) => {
  const badgeMode = getPartnerLogoMode(mode);
  if (badgeMode === PARTNER_LOGO_MODE.MANUAL) return null;
  const { src, area } = BADGES[badgeMode];
  return { src, logoBox: getLogoBox(area, getPartnerLogoScale(scale)) };
};
